/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React from 'react';
import PropTypes from 'prop-types';
import { withResolveByType } from '../withResolveByType';

const input = require('b_').with('input');

// eslint-disable-next-line no-underscore-dangle
const _GroupInput = React.memo((props) => {
    const {
        required, wrapperMod, type = 'text', disabled, id, label, error, Component, children, readOnly,
    } = props;

    return (
        <div
            className={input('group', {
                [type]: true,
                required,
                disabled,
                ...wrapperMod,
            })}
        >
            {!label || type === 'checkbox' || type === 'switch' ? null : (
                <label className={input('label', { [type]: true, required })} htmlFor={id}>
                    {label}
                </label>
            )}
            <div
                className={input('wrapper', {
                    error: !!error,
                    readonly: readOnly,
                })}
            >
                {/* eslint-disable-next-line react/jsx-props-no-spreading,no-undef */}
                <Component {...props} />
                {children}
                {!!error && <span className={input('message', { error: true })}>{error}</span>}
            </div>
        </div>
    );
});

_GroupInput.propTypes = {
    Component: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    wrapperMod: PropTypes.instanceOf(Object),
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    children: PropTypes.element,
    error: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string, //= 'text',
};

_GroupInput.defaultProps = {
    required: false,
    readOnly: false,
    disabled: false,
    type: 'text',
    wrapperMod: {},
    children: React.Element,
    label: '',
    error: '',
};

export const GroupInput = withResolveByType(_GroupInput);
